const DeltaStatus = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral'
};

export { DeltaStatus };
